import React, { CSSProperties } from "react";
import { IntlShape, useIntl } from "react-intl";
import { Header, Icon, List, Segment } from "semantic-ui-react";
// import moment from "moment";

// Serialzers
import PatientSerializer from "@/issara-sdk/types/PatientSerializer_apps_REG";
import ProxyPatientSerializer from "@/issara-sdk/types/ProxyPatientSerializer_apps_PRX";

const PRIMARY_COLOR = "#F382A0";

const styles = {
  sectionHeader: {
    background: PRIMARY_COLOR,
    padding: "8px 13px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    margin: 0,
  } as CSSProperties,
  sectionContent: { padding: "10px 13px", margin: 0 } as CSSProperties,
};

type ProfileSectionProps = {
  patientData?: PatientSerializer;
  proxyPatient?: ProxyPatientSerializer;
  isCollapsed: boolean;
  onToggle: () => void;
};

const convertYearBeToAd = (birthdate?: string | null): string => {
  if (!birthdate) return "";

  const parts = birthdate.split("/");
  if (parts.length !== 3) return birthdate;

  const [day, month, yearStr] = parts;
  const year = parseInt(yearStr, 10);

  const convertedYear = year > 2400 ? year - 543 : year;

  return `${day}/${month}/${convertedYear}`;
};

const formatGenderText = (intl: IntlShape, gender?: string): string => {
  if (!gender) return "";
  
  const isThaiLanguage = intl.locale === "th";

  if (["M", "1"].includes(gender)) return isThaiLanguage ? "ชาย" : "Male";
  if (["F", "2"].includes(gender)) return isThaiLanguage ? "หญิง" : "Female";

  return "";
};

const ProfileSection: React.FC<ProfileSectionProps> = (props) => {
  const intl = useIntl();

  const infoList = [
    { label: "ชื่อ - นามสกุล", value: `${props.patientData?.full_name || "-"}` },
    { label: "เพศ", value: formatGenderText(intl, props.proxyPatient?.extra_data?.gender) || "-" },
    { label: "วันเกิด", value: convertYearBeToAd(props.patientData?.birthdate) },
    { label: "อายุ", value: props.patientData?.full_age || "-" },
    { label: "เบอร์โทร", value: props.patientData?.present_address?.tel_mobile || "-" },
    { label: "E-mail", value: props.patientData?.present_address?.email || "-" },
  ];

  return (
    <Segment.Group style={{ marginBottom: "10px" }}>
      {/* Personal Info Header */}
      <Segment inverted style={styles.sectionHeader} onClick={props.onToggle}>
        <Header as="h5" inverted style={{ margin: 0, fontSize: "13px" }}>
          ข้อมูลส่วนบุคคล
        </Header>
        <Icon name={props.isCollapsed ? "angle down" : "angle up"} style={{ margin: 0 }} />
      </Segment>

      {/* Personal Info Content */}
      {!props.isCollapsed && (
        <Segment style={styles.sectionContent}>
          <List relaxed style={{ fontSize: "11px" }}>
            {infoList.map((item) => (
              <List.Item
                key={item.label}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {/* Label */}
                <strong
                  style={{
                    width: "80px",
                    flexShrink: 0,
                  }}
                >
                  {item.label}
                </strong>

                {/* Colon */}
                <span style={{ width: "10px", flexShrink: 0 }}>:</span>

                {/* Value */}
                <span style={{ whiteSpace: "pre-line" }}>{item.value}</span>
              </List.Item>
            ))}
          </List>
        </Segment>
      )}
    </Segment.Group>
  );
};

export default ProfileSection;
